export default "__VITE_ASSET__DEZAQOr1__"